import React, { useEffect, useState } from "react";
import "./style.css";
import axios from "axios";

const MaghzineOnline = () => {
  const [pageMessage, setPageMessage] = useState(
    "Hello,I'mInMaghzineOnlinePageFa"
  );
  const [taskName, setTaskName] = useState("");
  const [gameTitle, setGameTitle] = useState("");

  useEffect(() => {
    handleRedirect();
    handleStartGame();

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const receivedName = params.get("name");
    console.log("received task name is:", receivedName);

    if (receivedName === "AuditoryVisualCorsiblock") {
      setGameTitle("بازی کرسی بلاک - مهار پاسخ، سرعت عمل");
    } else if (receivedName === "Clouds") {
      setGameTitle("بازی ابرهای بارانی - توجه تقسیم شده، حافظه کاری، سرعت عمل");
    } else if (receivedName === "ControlResponsible") {
      setGameTitle(
        "بازی مسئول کنترل - توجه متمرکز، توجه پایدار، حافظه کاری، سرعت عمل، هوشیاری"
      );
    } else if (receivedName === "DeliciouseFinder") {
      setGameTitle("بازی خوشمزه‌یاب - توجه انتخابی، جابه‌جایی توجه، سرعت عمل");
    } else if (receivedName === "Highway") {
      setGameTitle("بازی بزرگراه - توجه انتخابی، مهار پاسخ، سرعت عمل");
    } else if (receivedName === "HoneyMemory") {
      setGameTitle("بازی حافظه عسلی - گستره توجه، حافظه کاری، هوشیاری");
    } else if (receivedName === "LostInLake") {
      setGameTitle("بازی گمشده در دریا - توجه انتخابی، مهار پاسخ، سرعت عمل");
    } else if (receivedName === "Puzzle") {
      setGameTitle("بازی پازل - توجه انتخابی، جابجایی توجه");
    }
    setTaskName(receivedName);
  }, []);

  const handleRedirect = async () => {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: pageMessage,
    });
  };

  const handleStartGame = async () => {
    const response = await axios.post(
      "https://request.kidiar.com/maghzine/request",
      { some: "some" },
      { headers: { "x-access-token": localStorage.getItem("token") } }
    );
  };

  return (
    <div className="container-fluid">
      <div className="row no-gutters">
        <div className="col-12">
          <div className="d-flex mb-3 align-items-center">
            <div className="d-flex flex-column ml-2">
              <p className="d-flex mb-2 align-items-center">
                <span>{gameTitle}</span>
              </p>
            </div>
          </div>
          <iframe
            src={`https://testfront.maghzineh.ir/playGame?type=maghzineh&task=${taskName}&id=829339`}
            title="Maghzine Highway Game - Attention"
            className="maghzineh-frame"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default MaghzineOnline;
